import Search from "../../MainContent/Search/Search";

const Minister = () => {
    return (
        <div>
            <div className="container">
                <Search />
                <h4 class="pb-4 pt-4 mb-4  ">
                    Вазир
                </h4>
                <div class="card mb-3" >
                    <div class="row g-1">

                        <div class="col-md-9">
                            <div class="card-body">
                                <h6 class="card-title text-center">САИДЗОДА РАҲИМ ҲАМРО</h6>
                                <h6 class="card-title text-center">ВАЗИРИ МАОРИФ ВА ИЛМИ ҶУМҲУРИИ ТОҶИКИСТОН</h6>
                                <p class="card-text" style={{ "textAlign": "justify" }}>
                                    7 июни соли 1969 дар Ҷумҳурии Тоҷикистон таваллуд шудааст, тоҷик, маълумоташ олӣ, доктори илмҳои техникӣ, профессор, дорандаи Ҷоизаи ба номи Исмоили Сомонӣ.
                                </p>
                                <h6 class="card-title text-center" >
                                    ФАЪОЛИЯТИ МЕҲНАТӢ:</h6>
                                <p class="card-text" style={{ "textAlign": "justify" }}>
                                    <small class="text-muted" >
                                        <p>
                                            <strong>
                                                Солҳои 1986-1993-
                                            </strong>
                                            донишҷӯйи Институти политехникии Тоҷикистон (ҳоло Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ);
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 1987-1989-
                                            </strong>
                                            хизмат дар сафи Қувваҳои мусаллаҳи Иттиҳоди Шӯравӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 1995-1997-
                                            </strong>
                                            ассистенти кафедраи бехатарии фаъолияти инсон ва экологияи Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 1997-1999-
                                            </strong>
                                            муаллими калони кафедраи бехатарии фаъолияти инсон ва экологияи Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 1999-2003-
                                            </strong>
                                            дотсенти кафедраи бехатарии фаъолияти инсон ва экологияи Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Соли 2003-
                                            </strong>
                                            сардори сектори илмӣ-тадқиқотии Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2003-2005-
                                            </strong>
                                            мудири кафедраи бехатарии фаъолияти инсон ва экологияи Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2004-2005-
                                            </strong>
                                            муовини ректор оид ба тарбияи Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2005-2009-
                                            </strong>
                                            директори Коллеҷи политехникии Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2009-2010-
                                            </strong>
                                            сардори раёсати аттестатсия, аккредитатсия ва иҷозатномаҳои муассисаҳои таълимии Хадамоти давлатии назорат дар соҳаи маорифи Вазорати маорифи Ҷумҳурии Тоҷикистон;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2010-2011-
                                            </strong>
                                            муовини сардори Хадамоти давлатии назорат дар соҳаи маорифи Вазорати маорифи Ҷумҳурии Тоҷикистон
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2011-2015-
                                            </strong>
                                            сардори Хадамоти давлатии назорат дар соҳаи маорифи Вазорати маорифи Ҷумҳурии Тоҷикистон;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2015-2017-
                                            </strong>
                                            сардори раёсати таҳсилоти ибтидоӣ ва миёнаи касбии Вазорати маориф ва илми Ҷумҳурии Тоҷикистон;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2015-2017-
                                            </strong>
                                            Солҳои 2017-2019-муовини аввал, муовини ректор оид ба таълими Донишгоҳи техникии Тоҷикистон ба номи академик М. Осимӣ;
                                        </p>
                                        <p>
                                            <strong>
                                                Солҳои 2019-2022-
                                            </strong>
                                            директори Филиали Донишгоҳи миллии таҳқиқотии технологӣ «МИСиС» дар ш.Душанбе;
                                        </p>
                                        Аз 21 феврали соли 2022 то ҳоло-вазири маориф ва илми Ҷумҳурии Тоҷикистон.
                                        Оиладор, соҳиби 5 фарзанд</small>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-3 p-4">
                            <img
                                src="https://maorif.tj/storage/posts/July2022/p2NdSl1NtVWoNCTlWKMF.jpg"
                                alt="Trendy Pants and Shoes"
                                class="img-fluid "
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Minister;